export const ClientBookingConfirmation = {
  en: {
    pageTitle: 'Review details and confirm your booking',
    locationLabel: 'Location',
    serviceLabel: 'Service',
    instructorLabel: 'Instructor',
    timeLabel: 'Time',
    costLabel: 'Cost',
    confirmButton: 'Confirm',
    payButton: 'Pay',
    'Select option': 'Select option',
    Event: 'Event',
    'Buy dialog title': 'Online Payment',
    'Buy dialog description':
      'You are about to purchase {{name}} for {{price}} UAH',
    Email: 'Email',
    'Email will be sent to the specified email':
      'Receipt will be sent to the specified email',
  },
  uk: {
    pageTitle: 'Перевірте деталі та підтвердіть замовлення',
    locationLabel: 'Локація',
    serviceLabel: 'Послуга',
    instructorLabel: 'Інструктор',
    timeLabel: 'Час',
    costLabel: 'Вартість',
    confirmButton: 'Підтвердити',
    payButton: 'Оплатити',
    'Select option': 'Оберіть опцію',
    Event: 'Подія',
    'Buy dialog title': 'Онлайн оплата',
    'Buy dialog description':
      'Ви збираєтесь придбати {{name}} за {{price}} грн',
    Email: 'Email',
    'Email will be sent to the specified email':
      'Квитанція буде відправлена на вказаний email',
  },
};
